<template>
  <el-container class="container">
    <el-header class="header">
      <div class="date">
        {{date}} {{weekday}} <span v-if="date === today" class="today">今天</span>
      </div>
      <div>
        <el-button plain @click="onCreatePlaylistClick">生成今日歌单</el-button>
        <el-button plain @click="onAddClick">添加</el-button>
      </div>
    </el-header>

    <el-table v-if="tableData.length" :data="tableData">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="songName" label="歌名" width="150"></el-table-column>
      <el-table-column prop="singerName" label="歌手" width="100"></el-table-column>
      <el-table-column prop="message" label="留言" width="200"></el-table-column>
      <el-table-column prop="nickname" label="点歌者花名" width="100"></el-table-column>
      <el-table-column prop="likeCount" label="点赞量" width="100"></el-table-column>
      <el-table-column label="评论数" width="100"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="mini">加入每周精选</el-button> -->
          <!-- <el-button size="mini">加入每月精选</el-button>
          <el-button size="mini">置顶</el-button> -->
          <el-button size="mini" @click="onDelete(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-else class="empty">今天没人点歌</div>
  </el-container>
</template>

<script>
import { Container, Header, Main, Button, Table, TableColumn, Row, Col, MessageBox } from 'element-ui'
import api from '@/api'
import bus from '@/utils/eventBus'
import dayjs from 'dayjs'

export default {
  name: 'DailyList',
  components: {
    [Container.name]: Container,
    [Header.name]: Header,
    [Main.name]: Main,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  props: {
    date: {
      type: String
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    // const item = {
    //   songName: '告白气球',
    //   singerName: '周杰伦',
    //   message: '我想和你谈个恋爱',
    //   nickname: '蛋挞',
    //   date: '2016-05-02',
    // }
    return {
      // date: '2019-07-19',
      tableData: [], // Array(5).fill(item)
      deleteIndex: null
    }
  },
  computed: {
    weekday () {
      const weekdayText = '日_一_二_三_四_五_六'.split('_')
      const d = dayjs(this.date).get('day')
      return `星期${weekdayText[d]}`
    },
    today: () => dayjs().format('YYYY-MM-DD').toString()
  },
  methods: {
    onCreatePlaylistClick() {
      // this.createPlaylistImg()
      bus.$emit('createCanvasImg', {
        date: this.date,
        list: this.list.slice(0, 3)
      })
    },
    onAddClick() {
      const newPage = this.$router.resolve({
        name: 'orderSong',
        query: {
          date: this.date,
          from: 'admin'
        }
      })
      window.open(newPage.href, '_blank')
    },
    async deleteOrder(id) {
      const res = await api.deleteOrder(id)
      if (res.code === 0) {
        this.$toast('删除成功')
        this.tableData.splice(this.deleteIndex, 1)
      } else {
        this.$toast(res.message)
      }
    },
    onDelete(data, index) {
      const { id } = data
      MessageBox.confirm('确定删除该歌曲吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteOrder(id)
        this.deleteIndex = index
      })
    }
  },
  created () {
    this.tableData = this.list
  }
}
</script>

<style lang="less" scoped>
// .container {
//   margin-top: 20px;
// }
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding-top: 10px;
  background: #f1f1f1;
}
.date {
  flex-shrink: 0;
  line-height: 60px;
}
.today {
  padding: 1px 2px;
  border: 1px solid #000;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1;
}
.empty {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/Daily.vue